import React                from 'react';
import styles               from './FileTransfer.scss';
import Icon                 from 'components/Icon/Icon.react';

export default function FileTransfer(props) {
  return (
    <div className={styles.container}>
      <div className={[styles.file, styles.fadeIn].join(' ')}>
        <Icon name='icon-file-transfer' width={80} height={100} colored={true} />
      </div>
      <div className={[styles.file, styles.zoomIn].join(' ')}>
        <Icon name='icon-file-transfer' width={80} height={100} colored={true} />
      </div>
      <div className={[styles.file, styles.zoomOut].join(' ')}>
        <Icon name='icon-file-transfer' width={80} height={100} colored={true} />
        <span className={[styles.fileCheck, styles.done].join(' ')}>
          <Icon name='icon-check' width={12} height={12} />
        </span>
      </div>
      <div className={[styles.file, styles.fadeOut].join(' ')}>
        <Icon name='icon-file-transfer' width={80} height={100} colored={true} />
        <span className={[styles.fileCheck].join(' ')}>
          <Icon name='icon-check' width={12} height={12} />
        </span>
      </div>
    </div>
  );
}